module.exports = __webpack_public_path__ + "static/media/soccer.17a96aa2.gif";